export enum EditProfileFields {
  first_name = 'first_name',
  last_name = 'last_name',
  email = 'email',
}

export type EditProfileSchema = {
  [EditProfileFields.first_name]: string;
  [EditProfileFields.last_name]: string;
  [EditProfileFields.email]: string;
}

export enum Field {
  name = 'name',
  email = 'email',
  description = 'description',
  phone = 'phone',
  website = 'website',
  instagram = 'instagram',
  facebook = 'facebook',
  linkedin = 'linkedin',
  twitter = 'twitter',
}
